import Sidebar from "@/components/Sidebar";

export default function AppShell({ children, title, subtitle, action }) {
    return (
        <div className="min-h-screen flex bg-zinc-950">
            <Sidebar />
            <main className="flex-1 min-w-0">
                <div className="max-w-6xl mx-auto px-6 md:px-10 py-8 md:py-12">
                    {(title || subtitle || action) && (
                        <div className="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                            <div>
                                {subtitle && (
                                    <div className="text-[11px] uppercase tracking-[0.22em] text-orange-400 mb-2 font-mono">
                                        {subtitle}
                                    </div>
                                )}
                                {title && (
                                    <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight" data-testid="page-title">
                                        {title}
                                    </h1>
                                )}
                            </div>
                            {action}
                        </div>
                    )}
                    {children}
                </div>
            </main>
        </div>
    );
}
